module.exports = __webpack_public_path__ + "img/programmer-with-idea.c990f009.png";